'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
require('react');
var common = require('@mshops-components-library/common');
var classNames = require('classnames');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var isDeepLink = function isDeepLink(link) {
  return link.startsWith('meli://') || link.startsWith('mercadopago://');
};
var navigationTo = function navigationTo(props) {
  var url = props.url,
    isWebview = props.isWebview,
    event = props.event;
  if (isWebview && isDeepLink(url)) {
    event.preventDefault();
    window.MobileWebKit.navigation.push(url)["catch"](function () {
      window.location = url;
    });
  }
};
var navigateTo = navigationTo;
var CategorySuper = function CategorySuper(_ref) {
  var namespace = _ref.namespace,
    styles = _ref.styles,
    content = _ref.content,
    isWebview = _ref.isWebview,
    layout = _ref.layout;
  var titleCategory = content.label,
    linkCategory = content.link.url;
  var urlImage = styles.background_image;
  var isNotDefaultLayout = layout !== 'square';
  var linkWrapperClasses = classNames__default["default"](namespace, _defineProperty({}, "".concat(namespace, "--").concat(layout), isNotDefaultLayout));
  var handleClick = function handleClick(event) {
    navigateTo({
      isWebview: isWebview,
      url: linkCategory,
      event: event
    });
    event.stopPropagation();
  };
  return /*#__PURE__*/_createRawReactElement("a", {
    className: linkWrapperClasses,
    href: linkCategory,
    onClick: function onClick(event) {
      return handleClick(event);
    }
  }, void 0, /*#__PURE__*/_createRawReactElement("div", {
    className: "".concat(namespace, "__link")
  }, void 0, /*#__PURE__*/_createRawReactElement("div", {
    className: "".concat(namespace, "__container")
  }, void 0, urlImage && /*#__PURE__*/_createRawReactElement(common.Image, {
    className: "".concat(namespace, "__image"),
    src: urlImage,
    onload: "on",
    alt: titleCategory,
    size: "small",
    lazyload: true
  }), /*#__PURE__*/_createRawReactElement("span", {
    className: "".concat(namespace, "__title")
  }, void 0, titleCategory))));
};
CategorySuper.defaultProps = {
  namespace: 'category-super-item',
  isWebview: false,
  layout: 'square'
};
var CategorySuper$1 = CategorySuper;
exports.CategorySuper = CategorySuper$1;
exports["default"] = CategorySuper$1;
